export function roleLabel(user) {
  if (user?.platform_admin) return "Platform Admin · Business Owner";
  return { owner: "Business Owner", manager: "Manager", collector: "Collector", viewer: "View Only" }[user?.role] || "Account";
}
export function visibleNavigation(items, user) {
  if (user?.role === "collector") return items.filter(n => ["/customers", "/overdue-customers"].includes(n.to));
  if (user?.role !== "owner") return items.filter(n => !["/settings", "/business-profile"].includes(n.to));
  return items;
}
export function homePath(user) { if (user?.must_change_password) return "/change-password"; return user?.role === "collector" ? "/customers" : "/"; }
